import React from "react";

import * as moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Chip, Tooltip } from "@material-ui/core";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useMenuBestOf } from "../../context/MenuBestOf";
import { useBestOf } from "../../context/BestOf";
// import { digest } from "../../utils/hash";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
  titleCardBestOf: {
    color: theme.palette.text.primary
  },
  chipError: {
    width: '-webkit-fill-available',
    margin: '5px'
  },
  chip: {
    margin: '5px'
  },
  tooltip: {
    fontSize: '0.8rem'
  }
}));

const LayoutItem = ({ bestof }: any) => {
  const classes = useStyles();
  const { dispatch } = useBestOf();
  const { dispatch: dispatchMenu } = useMenuBestOf();
  // const [value, setValue] = useState<any>(null);

  // useEffect(() => {
  //   digest('SHA-256', "thumbnail-" + bestof.created).then((value: any) => setValue(value));
  //   return () => {}
  // }, [])
 
  return (
    <Card className={classes.root} elevation={2}>
      <CardActionArea onClick={() => {
            if (!bestof.Oldbestof) {
              dispatchMenu({
                type: "SET_PICKED_BEST_OF",
                payload: { pickedBestOf: bestof },
              });
              dispatch({ type: "RESET_BEST_OF" });
            }
          }}>
        {/* {bestof.visible && bestof.publish && (
          <CardMedia
            className={classes.media}
            image={`https://atlantico-pdfs.s3.eu-west-3.amazonaws.com/best-of-thumbnails/${value}.png`}
            title={`best-of-image-id:${bestof.bestOfId}`}
          />
        )} */}
        <CardContent>
          <Typography className={classes.titleCardBestOf} gutterBottom variant="h6" component="h6">
            {bestof.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            <p>
              Date de création:{" "}
              {moment.utc(bestof.created).format("DD/MM/YYYY HH:mm")}
            </p>
            <p>
              Date de publication:{" "}
              {!bestof.publishDate || !bestof.publish
                ? "Pas encore publié"
                : moment.utc(bestof.publishDate).format("DD/MM/YYYY HH:mm")}
            </p>
          </Typography>
          <Typography>
            {bestof.isError && bestof.isError.status &&
              <Tooltip title={bestof.isError.message} placement="top" classes={{ tooltip: classes.tooltip }}>
                <Chip
                icon={<ErrorOutlineIcon />}
                color="secondary"
                label={bestof.isError.message}
                className={classes.chipError}
                />
              </Tooltip>
              }
            {bestof.visible && <Chip
              icon={<VisibilityIcon />}
              color="primary"
              label="Visible"
              className={classes.chip}
              />
            }
            {!bestof.visible && <Chip
              icon={<VisibilityOffIcon />}
              color="primary"
              label="Non visible"
              className={classes.chip}
              />
            }
            {bestof.Oldbestof && <Chip
              icon={<VisibilityIcon />}
              color="default"
              label="Ancien Best Of"
              className={classes.chip}
              />
            }
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default LayoutItem;
